module.exports = __webpack_public_path__ + "img/broadsign.6191e9b9.jpeg";